import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

import DiffLabel from 'dashboard/apps/InquiryTemplateEditor/DiffLabel';
import { VersionDiffChangeType } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import { Label } from 'design-system/components/Text';

const PropertyRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: ${Spacing[2]} 0;
  flex-grow: 1;
`;

const Property = styled(Label)`
  color: ${({ theme }) => theme.color.text.secondary};
`;

const PropertyLabel = styled(Label)`
  width: 50%;
  overflow-wrap: anywhere;
`;

const TablePropertyRow = ({
  textKey,
  value,
  changeType = null,
  className,
}: {
  textKey: string;
  value: ReactNode;
  changeType?: VersionDiffChangeType | null;
  className?: string;
}) => {
  return (
    <PropertyRowContainer className={className}>
      <PropertyLabel>
        <Property>{textKey}</Property>
      </PropertyLabel>
      <PropertyLabel>
        <DiffLabel changeType={changeType}>{value}</DiffLabel>
      </PropertyLabel>
    </PropertyRowContainer>
  );
};

export default TablePropertyRow;
